import { IBookingDetailsData } from "redux/application.types";
import axios from "./axios";
import urlJoin from "url-join";
import { Url } from "@edgetier/types";

/**
 * Request the booking details from the backend if there is a bookingId passed.
 * @param brandId The ID of the brand, if it is passed.
 * @param interactionDetailId The ID from interaction details.
 * @param bookingId The ID (booking ID or player ID) sent from interaction or added by user
 * @returns The booking details if there is a brand ID, null otherwise.
 */
export const getBookingDetails = async (
    brandId: number | null,
    interactionDetailId?: number | null,
    bookingId?: string | null
) => {
    const url =
        typeof interactionDetailId === "number"
            ? urlJoin(Url.Interactions, interactionDetailId.toString(), Url.AgentInformation)
            : urlJoin(Url.BookingDetails, (bookingId ?? "").toString());

    if (typeof brandId === "number") {
        const { data } = await axios.get<IBookingDetailsData>(url, { params: { brandId } });

        return data;
    }

    return null;
};
